import store from '../../store';

export default async (to, from, next) => {

    let pageName = null;
    pageName = to.name.split('-')[1];
    if (process.env.VUE_ENV === 'development')
        console.log({pageName})

    let permissions = await store.getters['permissions'];
    let auth = await store.getters['authenticated'];

    if (auth) {
        if (permissions.includes('viewAny ' + pageName)) {
            next();
        } else {
            let path = to.fullPath.split('/')[2] ? to.fullPath.split('/')[2] : to.fullPath.split('/')[1];
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission here to view ${path}`);
            next({path: from.path});
        }
    } else {
        next({name: 'login-page'});
    }
}